import { useState } from "react";
import { CSVCollaborator as BaseCSVCollaborator } from "../../../utils/csv/csv-validatorCollaborator";
export interface CSVCollaborator extends BaseCSVCollaborator {
  name: string;
  email: string;
  isValid: boolean;
  error?: string;
}
export function useCSVCollaboratorData() {
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [CSVCollaboratorError, setCSVCollaboratorError] = useState<string | null>(null);
  const [CSVCollaboratorPreviewData, setCSVCollaboratorPreviewData] = useState<CSVCollaborator[]>(
    []
  );
  const [invalidData, setInvalidData] = useState<CSVCollaborator[]>([]);
  const [fileInputKey, setFileInputKey] = useState(Date.now());
  const isValidEmail = (email: string): boolean => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };
  const isValidName = (name: string): boolean => {
    return name.length >= 3;
  };
  // Function to validate a collaborator
  function validateCollaborator(collaborator: CSVCollaborator): CSVCollaborator {
    let isValid = true;
    let error = "";
    if (!isValidName(collaborator.name)) {
      isValid = false;
      error += "Nome inválido. ";
    }
    if (!isValidEmail(collaborator.email)) {
      isValid = false;
      error += "Email inválido.";
    }
    return {
      ...collaborator,
      isValid,
      error: isValid ? undefined : error,
    };
  }
  // Function to handle CSV file upload and validation
  const handleCSVCollaboratorFileUpload = async (file: File) => {
    setSelectedFile(file);
    if (file) {
      try {
        const text = await file.text();
        const rows = text
          .split("\n")
          .map((row: string) =>
            row.split(",").map((cell: string) => cell.trim())
          )
          .filter((row) => row.length === 2 && row[0] && row[1]);
        const validCollaborators: CSVCollaborator[] = [];
        const invalidCollaborators: CSVCollaborator[] = [];
        rows.forEach((row) => {
          const name = row[0];
          const email = row[1];
          const collaborator = validateCollaborator({ name, email, isValid: true });
          if (collaborator.isValid) {
            validCollaborators.push(collaborator);
          } else {
            invalidCollaborators.push(collaborator);
          }
        });
        setCSVCollaboratorError(null);
        setCSVCollaboratorPreviewData(validCollaborators);
        setInvalidData(invalidCollaborators);
      } catch (error) {
        setCSVCollaboratorError(
          error instanceof Error ? error.message : "Erro ao ler o arquivo."
        );
      }
    }
  };
  return {
    selectedFile,
    setSelectedFile,
    CSVCollaboratorError,
    CSVCollaboratorPreviewData,
    invalidData,
    fileInputKey,
    setFileInputKey,
    validateCollaborator,
    handleCSVCollaboratorFileUpload,
    setCSVCollaboratorError,
    setCSVCollaboratorPreviewData,
    setInvalidData,
  };
}
